import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <section id="footer" className="footer-section">
      <p>
        <Link to="/imprint" className="accent-link">
          {t("imprint")}
        </Link>
      </p>
      <p>
        <Link to="/privacy" className="accent-link">
          {t("data-security")}
        </Link>
      </p>
      <p>© 2025</p>
    </section>
  );
}
